import React, {memo} from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import SwitchItems from "../../../../Components/FormBuilder/Builder/FormInputs/SwitchItems";
import SectionFormHeader from '../SectionTypeForm/SectionFormHeader';
import { isSet } from "../../../../Utils/CommonFunctions";

const ApprovalTypeForm = (props)=>{
  const {sectionIndex,isPopupWindow,modType,reminderDisplayText} = props;
  const section  = JSON.parse(props.section);
  const sectionData = section.data;


  const updateValueHandler = (field,e,type='TextInput')=>{
    console.log('updateValueHandler==',field,e,type)
    let {ruleActionName} = props;
    const {id} = field;
    const fieldKey = (field.api_custom_field_name && props.valuesObject && props.valuesObject[field.api_custom_field_name] !== undefined)
      ? field.api_custom_field_name
      : id;
        let fieldValue = null;
        let displayName = null;
        if(type==='MultiSelect'){
            let MultiSelectValue = [];
            e = (e===null)?[]:e;
            e.map((item)=>{
                MultiSelectValue.push(item.id);
                    return item;
            }); 
            fieldValue = MultiSelectValue.join(',');
        }else if(type==='CheckBoxes'){
            fieldValue = e.target.checked;
        }else if(type==='date'){
            fieldValue = isSet(e,'');
        }else if(['number','phoneNumber','PickList'].indexOf(type)!==-1){
            fieldValue = e
        }else if(['Lookup','MultiLookup'].indexOf(type)!==-1){
            fieldValue = e.selectedValue;
            displayName = e.displayValue;
            // console.log('e',e);
        }else if(type==='Files'){
            fieldValue = e;
        }else if(type==='Reminder'){
            fieldValue = e;
        }else{ 
            fieldValue = e.target.value;
        }
        const returnValue = [{
            name:'',
            data_id:'',
            //is_loop:false,
            value:fieldValue,
            //is_window_field:false,
            //is_variable_or_constant:false,
        }]
        console.log('returnValue==',returnValue)
        props.addDataRulesForActivitiesActionHandler(fieldKey,returnValue,ruleActionName,'ASSIGN_TASK');
  }

  return(
    <div className="col-12 mb-2" key={sectionIndex}>
    <div className="card-outer">
        <SectionFormHeader title={section.title} secId={section.id} isQuickCreate={props.isQuickCreate} />
         <div className={`form-body pt-2 p-2 show`} id={section.id}>
             <div className="row" key={"forms"+sectionIndex}>
                 {
                    sectionData.map((item,itemIndex)=>{

                    // if(item.element==='Date' || item.element==='DateTime'){
                    //   console.log('sectionform',item)
                    // }
                  
                    //For Quick Create Form
                    if(props.isQuickCreate===true){
                        item.quickCreateFrom = true;
                        if(item.quickCreate==false){
                        return false;
                        }
                    }
                    const fieldObj = {
                        section_index:section.section_index,
                        sectionId:section.id,
                        itemIndex:item.itemIndex,
                        modType:modType,
                        item:{
                            ...item,
                            modType:modType
                        },
                    }

                    let updateItem = {...item,modType:modType};
                    let elementType = (item.element==='Date' || item.element==='DateTime')?'Number':item.element;
                    let editHandler = ()=>{}
                    let myArrayConst = props.valuesObject[item.id];
                    console.log('myArrayConst==',myArrayConst,props.valuesObject,item.id)
                    try{
                        if (myArrayConst === undefined && item.api_custom_field_name) {
                            myArrayConst = props.valuesObject[item.api_custom_field_name];
                          }
                          
                        let selectedValue = item.selectedValue;
                        const dynamicValue = isSet(myArrayConst?.[0]?.value, null);
                        
                        let elementType = (item.element==='Date' || item.element==='DateTime')?'Number':item.element;
                        let isEditEnable = false;
                        const hasSelectedValue = !(selectedValue === null || selectedValue === undefined || selectedValue === '');
                        if (!hasSelectedValue && dynamicValue !== null && typeof dynamicValue !== 'object') {
                            selectedValue = dynamicValue;
                          }
                        updateItem = {
                            ...updateItem,
                            element:elementType,
                            isEditEnable:isEditEnable,
                            editHandler:editHandler,
                            //removeHandler:removeHandler,
                            selectedValue:selectedValue,//isSet(props.valuesObject[item.id][0].name,null),
                            reminder:isSet(dynamicValue,''),
                        }
                    }catch(e){

                    }

                    const btnGroup = []

                    updateItem = {
                        ...updateItem,  
                        element:elementType,                  
                        //lookupFieldsData:lookupFieldsData,
                        //updateValuesObjectHandler:updateValuesObjectHandler,
                        btnGroup:btnGroup,
                    }

                    return(
                        <SwitchItems 
                            key={itemIndex}
                            item={updateItem}
                            section={section}
                            fieldObj={fieldObj}
                            isPopupWindow={isPopupWindow}
                            layoutForms={true} 
                            reminderDisplayText={reminderDisplayText}
                            screen="Approval"
                            {...props} 
                            onChangeInputAction={(obj,val,type)=>{
                                props.onChangeInputAction(obj,val,type);
                                updateValueHandler(item,val,type);
                            }}
                        />
                    )
                })}
             </div>
         </div>
         </div>
     </div>
  )
};


export default memo(ApprovalTypeForm);
